import React from 'react';

import { ReportOrderContraEntry } from '@/services/innovorder/orders/order.type';
import { Container, ItemContainer, StyledLabel, StyledTitle } from './OrderDetailsContraEntryInfos.style';

type OrderDetailsContraEntryInfosProps = ReportOrderContraEntry & {
    cancellationReasonDescription: string | null;
};

const OrderDetailsContraEntryInfos: React.FunctionComponent<
    React.PropsWithChildren<OrderDetailsContraEntryInfosProps>
> = ({ user, cancellationReasonDescription }) => {
    return (
        <Container>
            <ItemContainer>
                <StyledLabel text="orderDetail.contraEntryInfo.validator" />
                <StyledTitle type="small" weight="medium" text={`${user.firstName} ${user.lastName}`} noTranslation />
            </ItemContainer>
            {cancellationReasonDescription && (
                <ItemContainer>
                    <StyledLabel text="orderDetail.contraEntryInfo.cancellationReasonDescription" />
                    <StyledTitle type="small" weight="medium" text={cancellationReasonDescription} noTranslation />
                </ItemContainer>
            )}
        </Container>
    );
};

export default OrderDetailsContraEntryInfos;
